import { render, staticRenderFns } from "./sliders.vue?vue&type=template&id=0c24fc2e&scoped=true"
import script from "./sliders.vue?vue&type=script&lang=js"
export * from "./sliders.vue?vue&type=script&lang=js"
import style0 from "./sliders.vue?vue&type=style&index=0&id=0c24fc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24fc2e",
  null
  
)

export default component.exports